import { useEffect } from 'react'

import { ideApi, runtimeApi } from '@/api/ideApi'
import { useIdeStore } from '@/store/ideStore'

export function useSessionHeartbeat(enabled, governedRuntime) {
  const setUsageSnapshot = useIdeStore(state => state.setUsageSnapshot)

  useEffect(() => {
    if (!enabled) {
      return undefined
    }

    const tick = async () => {
      try {
        const usage = await ideApi.getUsage()
        if (usage?.data) {
          setUsageSnapshot(usage.data)
        }
      } catch {
        // silently ignore transient failures
      }
    }

    tick()
    const intervalId = window.setInterval(tick, 15000)
    const runtimeTick = async () => {
      if (!governedRuntime) return
      try {
        await runtimeApi.heartbeat()
      } catch {
        // The server remains authoritative; the next refresh exposes expiry or revocation.
      }
    }
    const runtimeIntervalId = governedRuntime
      ? window.setInterval(runtimeTick, 60000)
      : null
    return () => {
      window.clearInterval(intervalId)
      if (runtimeIntervalId) window.clearInterval(runtimeIntervalId)
    }
  }, [enabled, governedRuntime, setUsageSnapshot])
}
